import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/theme-provider";
import { Button } from "@/components/ui/button";

export function LoginHeader() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex items-center gap-4">
      {/* Theme Switcher */}
      <Button
        variant="outline"
        size="icon"
        className="rounded-full bg-white/60 dark:bg-slate-900/60 backdrop-blur-md border-white/20 shadow-sm"
        onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      >
        <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 text-muted-foreground" />
        <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 text-muted-foreground" />
        <span className="sr-only">Toggle theme</span>
      </Button>
    </div>
  );
}

export default LoginHeader;

